import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ListValues, FormInputConfig, AllInputTypes } from '../../../../../trash/shared/interfaces/form-input-config';
import { IGeographicalZoneResponse, IUpdateGeographicalZoneReqeust } from '../dtos';
import { patterns } from '../../../../../lib/formly/patterns';

export class UpdateGeographicalZoneModel implements IUpdateGeographicalZoneReqeust {
  id?: string;
  englishName?: string;
  countryId: string;
  description?: string;

  constructor(request: IUpdateGeographicalZoneReqeust) {
    this.id = request.id;
    this.englishName = request.englishName;
    this.countryId = request.countryId;
    this.description = request.description;
  }

  static create(data: IUpdateGeographicalZoneReqeust): UpdateGeographicalZoneModel {
    return new UpdateGeographicalZoneModel(data);
  }

  static createDefault(): UpdateGeographicalZoneModel {
    return UpdateGeographicalZoneModel.create({
      id: '',
      englishName: '',
      countryId: ''
    });
  }

  static createFromItem(item: IGeographicalZoneResponse): UpdateGeographicalZoneModel {
    return new UpdateGeographicalZoneModel({
      id: item.id,
      englishName: item.englishName,
      countryId: item.country.id,
      description: item.description
    });
  }

  getFormConfig(countries: ListValues[], isVisible?: boolean, translate?: TranslateService): FormInputConfig[] {
    return [
      // getIdFormConfig(this.id),
      {
        type: AllInputTypes.Text,
        name: 'englishName',
        label: translate?.instant('LOCATION_MANAGEMENT.GEOGRAPHICAL_ZONE_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.GEOGRAPHICAL_ZONE_NAME')}`,
        defaultValue: this.englishName,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.GEOGRAPHICAL_ZONE_NAME')}`
          },
          {
            function: Validators.pattern(patterns.onlyEnglishCharacters),
            errorMessage: translate?.instant('SERVICE_MANAGEMENT.VALIDATION_ONLY_ENGLISH'),
            errorName: 'pattern'
          }
        ]
      },
      {
        type: AllInputTypes.Select,
        name: 'countryId',
        label: translate?.instant('LOCATION_MANAGEMENT.COUNTRY_NAME'),
        placeholder: translate?.instant('GENERAL.SELECT'),
        widthClass: 'col-12',
        defaultValue: this.countryId,
        isDisable: !isVisible,
        listValues: countries,
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_SELECT')} ${translate?.instant('LOCATION_MANAGEMENT.COUNTRY_NAME')}`
          }
        ]
      },
      {
        type: AllInputTypes.Textarea,
        name: 'description',
        label: translate?.instant('GENERAL.DESCRIPTION'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('GENERAL.DESCRIPTION')}`,
        defaultValue: this.description,
        isDisable: !isVisible,
        widthClass: 'col-12'
      }
    ];
  }
}
